module.exports = __webpack_public_path__ + "img/introduce_1.16a826fb.png";